'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './store'

interface Props {
  children: React.ReactNode
}

export function StoreProvider({ children }: Props) {
  const [isClient, setIsClient] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    setIsClient(true)
  }, [])

  // Pause persistence on static pages
  useEffect(() => {
    if (pathname.startsWith('/about') || pathname.startsWith('/privacy') || pathname.startsWith('/terms')) {
      persistor.pause()
    } else {
      persistor.persist()
    }
  }, [pathname])

  return (
    <Provider store={store}>
      {isClient ? (
        <PersistGate
          loading={null}
          persistor={persistor}
        >
          {children}
        </PersistGate>
      ) : (
        children
      )}
    </Provider>
  )
}
